module.exports = __webpack_public_path__ + "src/assets/img/visual_ring-pattern.f2699abd.jpg";